// extracted by mini-css-extract-plugin
export var danger = "_48-6";
export var lightPink = "_48-a";
export var medium = "_48-j";
export var nearSquare = "_48-m";
export var neutralBlue = "_48-8";
export var neutralYellow = "_48-7";
export var noCapitalize = "_48-1";
export var normal = "_48-2";
export var pill = "_48-0";
export var primary = "_48-3";
export var primaryLight = "_48-4";
export var shadow = "_48-n";
export var small = "_48-k";
export var solidBlack = "_48-i";
export var solidGreen = "_48-d";
export var solidLightBlue = "_48-f";
export var solidNavy = "_48-e";
export var solidOrange = "_48-h";
export var solidPink = "_48-g";
export var solidRed = "_48-b";
export var solidWhite = "_48-9";
export var solidYellow = "_48-c";
export var success = "_48-5";
export var xsmall = "_48-l";